var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2752 29.4305L52.8549 10.7252C52.4487 10.4907 51.9879 10.3672 51.5188 10.3672C51.0498 10.3672 50.5889 10.4907 50.1827 10.7252L17.7658 29.4305C17.36 29.6648 17.0229 30.0017 16.7884 30.4074C16.5539 30.8131 16.4302 31.2733 16.4297 31.7419V69.1759C16.4296 69.6451 16.553 70.106 16.7875 70.5124C17.0221 70.9187 17.3595 71.2561 17.7658 71.4907L50.1827 90.196C50.5889 90.4306 51.0498 90.554 51.5188 90.554C51.9879 90.554 52.4487 90.4306 52.8549 90.196L85.2752 71.4907C85.6815 71.2561 86.0189 70.9187 86.2534 70.5124C86.488 70.106 86.6114 69.6451 86.6113 69.1759V31.7419C86.6108 31.2733 86.4871 30.8131 86.2526 30.4074C86.0181 30.0017 85.681 29.6648 85.2752 29.4305Z",
    fill: "#9147ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1309 36.6757V66.367L29.4794 70.6091V40.9178L36.8245 45.1599V53.6441L44.163 49.4086L44.173 40.9178L29.4794 32.4336L22.1309 36.6757Z",
    fill: "lightgray"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.906 36.6757V66.367L73.5609 70.6091V40.9178L66.2124 45.1599V53.6441L58.8772 49.4086L58.8672 40.9178L73.5609 32.4336L80.906 36.6757Z",
    fill: "lightgray"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1935 53.4505V38.7969L66.2162 32.4337V23.9529L51.5192 32.4337L36.8222 23.9529V32.4337L47.845 38.7969V53.4505C47.8448 54.154 47.6596 54.845 47.3078 55.4542C46.956 56.0634 46.4501 56.5693 45.8408 56.921L33.1479 64.2461V76.9691L40.4965 72.727V64.2428L51.5192 57.8796L62.542 64.2428V72.727L69.8905 76.9691V64.2428L57.1976 56.9176C56.5889 56.5662 56.0833 56.0609 55.7315 55.4523C55.3797 54.8437 55.1942 54.1534 55.1935 53.4505Z",
    fill: "lightgray"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.803845852c3ebbab6498839a97f42eb3.svg";
export { ForwardRef as ReactComponent };